<template>
  <el-dialog
    title="Add Artist/Label"
    :visible="dialog_form"
    width="500px"
    top="3vh"
    :modal="true"
    @close="close"
  >
    <el-form ref="label" :model="label">
      <el-form-item label="Name" prop="name">
        <el-input type="text" v-model="label.name" clearable />
      </el-form-item>
      <el-form-item label="User type" prop="user_type">
        <el-select
          v-model="label.user_type"
          @change="change"
          clearable
          filterable
          class="mr10 capitalize"
        >
          <el-option value="label" label="Label"></el-option>
          <el-option value="artist" label="Artist"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Label" prop="label" v-show="label_type">
        <el-select v-model="label.label" clearable filterable class="mr10">
          <el-option
            v-for="a in allLabels"
            :key="a.user.user_id"
            :value="a.user.user_id"
            :label="a.name"
            @click.native="setName(a.name)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Artist" prop="artist" v-show="artist_type">
        <el-select v-model="label.artist" clearable filterable class="mr10">
          <el-option
            v-for="a in allArtists"
            :key="a.user.user_fk"
            :value="a.user.user_fk"
            :label="a.name"
            @click.native="setName(a.name)"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" size="mini" @click="submit">
        Save
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('vcLabel', [
      'label',
      'dialog_form',
      'users',
      'allLabels',
      'allArtists'
    ]),
    artist_type: function() {
      if (this.label.user_type == 'artist') return true
      else {
        return false
      }
    },
    label_type: function() {
      if (this.label.user_type == 'label') return true
      else {
        return false
      }
    }
  },

  data() {
    return {
      label_ini: {
        id: null,
        name: '',
        user_type: null,
        artist: null,
        label: null
      }
    }
  },

  methods: {
    ...mapActions('vcLabel', ['createLabel', 'getLabel', 'getArtist']),
    ...mapMutations('vcLabel', ['setLabelForm', 'setLabel']),
    ...mapMutations('newReleasesLabels', ['setDialog']),
    submit() {
      this.createLabel()
    },

    setName(name) {
      this.label.name = name
    },

    change() {
      this.label.artist = null
      this.label.label = null
      this.label.name = null
    },

    close() {
      this.setLabelForm(false)
      this.setLabel(this.label_ini)
    }
  },

  created() {
    this.getLabel()
    this.getArtist()
  }
}
</script>
